var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { block } from "bem-cn";
import React from "react";
import DatePickerControl from "react-datepicker";
export { getDefaultLocale, registerLocale, setDefaultLocale } from "react-datepicker";
const controlStyle = block("form-control");
const DatePicker = (_a) => {
    var { calendarClassName, noBorder, footer, isInvalid } = _a, props = __rest(_a, ["calendarClassName", "noBorder", "footer", "isInvalid"]);
    if (noBorder) {
        calendarClassName = calendarClassName ? `${calendarClassName} no-border` : "no-border";
    }
    const className = controlStyle.mix(props.className, isInvalid && "is-invalid");
    return (React.createElement(DatePickerControl, Object.assign({}, props, { className: className.toString(), calendarClassName: calendarClassName }), footer && React.createElement("div", { className: "react-datepicker__footer" }, footer)));
};
DatePicker.defaultProps = {
    dateFormat: ["PP", "P"],
    showPopperArrow: false,
    popperPlacement: "bottom",
    popperModifiers: {
        flip: { enabled: false },
    },
};
export default DatePicker;
//# sourceMappingURL=index.js.map